const initialState = {
    eventsByGroups: [],
    refDataEventProcess: [],
    refDataEventProcessOrders: [],
    gridOptions: {},
    rowData: [],
    widgetEvent: [],
};
export default initialState;
